/* unplugin-vue-components disabled */import { render } from "./Vue.vue?vue&type=template&id=28565d9a"
const script = {}

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__